<template>
    <div class="warp-tree" :style='{width:width+"px"}'>
        <el-popover  placement="bottom-start" :width="width-25" trigger="click">
            <el-input slot="reference" v-model="inputValue" readonly :style='{width:width+"px",textAlign:"left"}' :placeholder="placeholder"></el-input>
            <div class="blockJIEKOU">
                <el-tree  :data="options"  ref="tree" :check-on-click-node="true" :check-strictly="true"  show-checkbox  node-key="id" :default-checked-keys="defaultVal" :props="defaultProps"  @check-change="handleCheckChange"></el-tree>
            </div>
        </el-popover>
    </div>
</template>
<script>
 export default{
    data:()=>({
        inputValue:"",
        defaultProps: {
          children: 'children',
          label: 'name'
        }
    }),
    props:{
        defaultVal:{
            type: Array,
            default: function () { return [] } 
        },
        keyVal:{
            type: String,
            default: "keyVal",  
        },
        width:{
          type: String,
          default: "200",  
        },
        placeholder:{
            type: String,
            default: "请选择",
        },
        keyId:{
            type: String,
            default: "id", 
        },
        labelKey:{
            type: String,
            default: "name", 
        },
        childKey:{
            type: String,
            default: "",  
        },
        options:{
            type:Array,
        }
    },
    created(){
        
       //监听选中的文字  非常鸡肋的写法后期更改
    //    setInterval(resdas=>{
         
    //    },1000)
        setTimeout(res=>{
            this.setTexFun()
        },1000)
    },
    mounted(){
       
    },
    methods:{

        //获取选中的值
        handleCheckChange() {
            let res = this.$refs.tree.getCheckedNodes()
            let arrDeptId = []
            let name = []
            res.forEach((item) => {
                arrDeptId.push(item.id)
                name.push(item.name)
            })
            this.inputValue = name.length==0 ? "" : name.join(" / ")
            this.$emit("getVal",{key:this.keyVal,val:arrDeptId})
           
        },

        //设置文字显示
        setTexFun(){
            let res = this.$refs.tree.getCheckedNodes()
            let arrDeptId = []
            let name = []
            res.forEach((item) => {
                arrDeptId.push(item.id)
                name.push(item.name)
            })
            this.inputValue = name.length==0 ? "" : name.join(" / ")
        },

       //设定选中的值
        setVal(ev){
          this.defaultVal = ev
        },
    }
 }
</script>
<style lang="scss" scoped>
    .blockJIEKOU{
        max-height: 200px;
        min-height: 100px;
        overflow-y: auto;
    }
</style>